module.exports = __webpack_public_path__ + "static/sheep2-ad5205004f289975be394514108769ae.jpeg";